import { colors } from '../theme';

/** Shared channel → Ionicons name / brand color mapping — extracted from
 * InboxScreen's private getProviderIcon/getProviderColor so ReportsScreen (and any
 * future consumer) doesn't re-duplicate the same switch statement a third time. */
export function getChannelIcon(channel: string): string {
  switch ((channel || '').toLowerCase()) {
    case 'whatsapp':
      return 'logo-whatsapp';
    case 'telegram':
      return 'paper-plane';
    case 'facebook':
    case 'facebook-messenger':
    case 'messenger':
      return 'logo-facebook';
    case 'instagram':
      return 'logo-instagram';
    case 'twitter':
    case 'x-twitter':
    case 'x':
      return 'logo-twitter';
    case 'email':
      return 'mail';
    case 'phone':
      return 'call';
    case 'visit':
      return 'location';
    default:
      return 'chatbubble';
  }
}

export function getChannelColor(channel: string): string {
  switch ((channel || '').toLowerCase()) {
    case 'whatsapp':
      return '#25D366';
    case 'telegram':
      return '#0088CC';
    case 'facebook':
    case 'facebook-messenger':
    case 'messenger':
      return '#1877F2';
    case 'instagram':
      return '#E4405F';
    case 'twitter':
    case 'x-twitter':
    case 'x':
      return '#000000';
    case 'email':
      return '#EA4335';
    case 'phone':
      return '#0EA5E9';
    case 'visit':
      return '#F59E0B';
    default:
      return colors.primary as string;
  }
}
